import { Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CopyStages, NodeActionsService } from '../../services/node-actions.service';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { Branch } from '../../component-loader/branch-options';
import { Observable } from 'rxjs';
import { ChangeSideMenuContent } from '../../workflow-viewer-v2/workflow-viewer-v2.service';

export interface PasteEvent {
  branch: Branch;
  precedingSteps: string[];
}

@Component({
  selector: 'automata-add-step',
  templateUrl: './add-step.component.html',
  styleUrls: ['./add-step.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, GalaxyLoadingSpinnerModule, TranslateModule],
})
export class AddStepComponent {
  @Input() disabled: Observable<boolean>;
  @Input() precedingSteps: string[];
  @Input() branch: Branch;
  @Input() groupId: string;

  @Output() addStepClick = new EventEmitter();
  @Output() pasteStepClick = new EventEmitter<PasteEvent>();
  @Output() changeSideMenuContent: EventEmitter<ChangeSideMenuContent> = new EventEmitter<ChangeSideMenuContent>();

  copyStage$ = this.nodeActionService.copyingStage$;
  copyStage = CopyStages;

  isCopying = false;

  constructor(
    private readonly nodeActionService: NodeActionsService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.copyStage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((stage) => {
      if (stage === CopyStages.Unselected) {
        this.isCopying = false;
      }
    });
  }
  addStepClicked(): void {
    this.changeSideMenuContent.emit({
      requestingId: '',
      menuType: 'selectNewStep',
      branch: this.branch,
      precedingSteps: this.precedingSteps,
      groupId: this.groupId,
    });
  }
}
